let fetchUrl = {
  // 概况模块
  pandect: {
    // 概况 数据统计
    mySummary: '/proxy/myDaydetail',
    // 统计首页
    homePage: '/proxy/totalHomePage',
    // * 今日统计（包含前6日）
    // * @param uid 用户ID
    // * @param flag true:统计前7天 false:当天
    // * @param type 类型 : 1.充值统计 2.提现统计 3.投注金额统计 4.返佣金额统计 5.新增会员统计 6.活跃用户统计
    // * @param status 返回前台页面传1
    countToday: '/proxy/countToday',
    // 统计报表
    // uid 用户ID
    // nextProxyType 下线类型：0、全部下线 1、直属下线
    // startTime 开始时间  endTime  结束时间
    getReport: '/proxy/getReport',
    teamStatist:'/proxy/teamStatist',
  },
  // 管理员管理模块
  admin : {
    // 管理员登录
    login: '/login',
    //测试调用 /proxy/index
    testIndex: '/proxy/index',
    // 获取代理人员列表
    proxyList: '/proxy/list',
    // 获取代理中的下级会员列表
    proxyUserList: '/proxy/proxyuserlist',
    // 获取会员列表
    userList: '/proxy/userlist',
    //获取投注记录列表
    orderList: '/proxy/order',
    //投注详情
    orderDetail: '/proxy/touzhuDetail',
    // 获取用户最新余额
    fetch_balance: '/proxy/proxyIndex',
    // 我的返佣
    proxy_order_list: '/proxy/order',
    // 充值,提现列表
    proxy_pay_list: '/proxy/paylist',
    // 获取我的下级列表
    myAgentList: '/proxy/proxyUser',
    // 获取代充列表
    agentTopUpList: '/proxy/proxyCharge',
    // 获取转充充列表
    agentTurnToList: '/proxy/transferList',
    // 获取赠送列表
    giveawayList: '/proxy/proxyGiveaway',
    // 代理盈亏
   agentProfitLoss: '/proxy/platformStatis',
    //会员购彩列表
    memberPurchase: '/proxy/memberPurchaseList',

  },

  // 用户管理模块
  user: {
    // 修改密码
    setPassword: '/proxy/userpwd',
  },
  // 代理管理模块
  agent: {
    // 代理列表
    index: '/proxy/list',
    // 代理权限管理
    proxyEdit: '/proxy/proxyEdit',
    // 代付
    payMoney: '/proxy/pay',
    // 提升为代理
    proxyConf: '/proxy/getProxyConf',
    // 会员转移
    moveUserRelation: '/proxy/moveUserRelation',
    // 会员转移
    moveProxyRelation: '/proxy/moveProxyRelation',
    //会员设置是否常规时间购彩
    getProxyEnable:'/proxy/getProxyEnable'
  },
}

export default fetchUrl;



// WEBPACK FOOTER //
// ./src/service/fetchUrl.js